import { screenResizerChecker } from '@src/utils/screen-resizer-checker';
import { ScreensInt } from '@tailwindConfig/screens.config';

document.addEventListener('DOMContentLoaded', () => {
  const topBar = document.querySelector('#prismic-top-bar');

  let storageKey = '';
  document.querySelectorAll('.top-bar-message').forEach((content) => {
    storageKey = storageKey + content.dataset.message;
  });

  document.querySelectorAll('.top-bar-message a').forEach((content) => {
    content.classList.add('underline', 'top-bar-message-link', 'z-100', 'relative');
    content.style.textUnderlineOffset = '4px';
    content.insertAdjacentHTML('beforeend', '<i class="inline-block icon-arrow-right ml-4"></i>');
    topBar.insertAdjacentHTML('beforeend', `<a style="height: 56px;" class="absolute top-0 left-0 w-full z-50" href=${content.href}></a>`);
  });

  const config = {
    topBarClosed: true,
    desktopDevice: function () { return !this.mobileDevice(); },
    mobileDevice: function () { return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); },
    safariDevice: function () { return /Version\/[\d.]+.*Safari/i.test(navigator.userAgent); },
    iosDevice: function () { return this.mobileDevice() && this.safariDevice(); },
    androidDevice: function () { return this.mobileDevice() && !this.safariDevice(); }
  };

  if (topBar) {
    // Checking if text of messages is stored in localStorage
    // If yes, we already saw the banner and want to hide it
    if (localStorage.getItem(storageKey)) {
      topBar.classList.add('hidden');
      // Now we have shown (or not) the banner, we save the key in localStorage to avoid showing it again
      const closeTopBar = topBar.querySelector('.close-top-bar');
      closeTopBar?.addEventListener('click', () => localStorage.setItem(storageKey, true));
    } else {
      const setBackgroundColor = () => {
        const selectedBackgroundColor = topBar?.dataset?.background;
        if (['black', 'white'].includes(selectedBackgroundColor)) {
          return `bg-primary-${selectedBackgroundColor}`;
        } else if (selectedBackgroundColor === 'grey') {
          return 'bg-grey-300';
        } else {
          return `bg-${selectedBackgroundColor}-800`;
        }
      };

      const backgroundColor = setBackgroundColor();
      const animationType = topBar?.dataset?.animation;
      if (['purple_fade', 'black_fade'].includes(animationType)) {
        animateBanner(topBar, animationType);
      } else {
        topBar.classList.add(backgroundColor);
        if (['bg-primary-black', 'bg-purple-800'].includes(backgroundColor)) topBar.classList.add('text-primary-white');
      }

      // Showing correct message depending on device
      if (config.desktopDevice()) document.querySelector('.banner_desktop_text_message')?.classList?.remove('hidden');
      if (config.iosDevice()) document.querySelector('.banner_android_text_message')?.classList?.remove('hidden');
      if (config.androidDevice()) document.querySelector('.banner_ios_text_message')?.classList?.remove('hidden');

      // --- Add padding to section or navbar when banner ---

      // Add some margin to the video overlay when a banner is present to allow it to breathe a bit from the navbar
      // Get initial padding-top of section and the top bar (ie the banner)
      const firstSectionInitialPadding = parseInt(window.getComputedStyle(document.querySelector('section')).getPropertyValue('padding-top'));
      const topBarHeight = document.querySelector('#prismic-top-bar')?.offsetHeight;

      // If there is a video wrapper present we need to do the same for it as above
      const videoWrapperElement = document.querySelector('.video-wrapper');
      let videoWrapperTopPosition = 0;

      if (videoWrapperElement) {
        document.querySelector('#video-overlay')?.classList?.add('md:mt-20', 'lg:mt-48');

        videoWrapperTopPosition = window.getComputedStyle(videoWrapperElement).getPropertyValue('top');

        // Add topbar height to section initial padding-top and video wrapper top position
        videoWrapperElement.style.top = `${parseInt(videoWrapperTopPosition) + topBarHeight}px`;
      }

      const setSizes = () => {
        // Hardcoded to sync with what is in app/sections/video/_section.scss - keep synced or face the music
        document.querySelector('section').style.paddingTop = '56.2%';
        document.querySelector('section').style.paddingTop = `${parseInt(window.getComputedStyle(document.querySelector('section')).getPropertyValue('padding-top')) + topBarHeight}px`;
      };

      if (videoWrapperElement) {
        setSizes();
        window.addEventListener('resize', () => { setSizes(); });
      } else {
        document.querySelector('section').style.paddingTop = `${firstSectionInitialPadding + topBarHeight}px`;
      }

      const addPaddingNavbar = () => {
        document.querySelector('.toggle-item').style.paddingTop = `${topBarHeight}px`;
      };
      const removePaddingNavbar = () => {
        document.querySelector('.toggle-item').style.paddingTop = '0px';
      };

      // If on small screen, add padding to first element of navbar
      screenResizerChecker(() => addPaddingNavbar(), () => removePaddingNavbar(), ScreensInt.md);

      // Close topbar and remove extra padding
      document.querySelector('.close-top-bar').addEventListener('click', (event) => {
        event.preventDefault();
        if (window.location.pathname.indexOf('/payment-methods/card/x-card') >= 0) {
          header.style.transform = `translateY(-${topBarHeight}px)`;
          setTimeout(() => {
            // header.classList.remove('x-card-banner-animation');
            header.style.transform = '';
            topBar.remove();
          }, 500);
        } else {
          topBar.remove();
        }
        removePaddingNavbar();

        if (videoWrapperElement) {
          // Hardcoded to sync with what is in app/sections/video/_section.scss - keep synced or face the music
          document.querySelector('section').style.paddingTop = '56.2%';
          document.querySelector('.video-wrapper').style.top = `${parseInt(videoWrapperTopPosition)}px`;
          document.querySelector('#video-overlay')?.classList?.remove('md:mt-20', 'lg:mt-48');
          window.removeEventListener('resize', () => { setSizes(); });
        } else {
          document.querySelector('section').style.paddingTop = `${firstSectionInitialPadding}px`;
        }
      });

      const header = document.querySelector('header');
      if (window.location.pathname.indexOf('/payment-methods/card/x-card') >= 0) {
        document.querySelector('.base-page').style.paddingTop = '60px';
        header.style.transform = 'translateY(0)';
        setTimeout(() => {
          topBar.style.backgroundColor = '#636360';
          topBar.style.color = 'white';
          document.querySelectorAll('.close-top-bar path').forEach(path => {
            path.style.fill = 'white';
          });
        }, 2500);
      }
    }
  }
});

const animateBanner = (topBar, animationType) => {
  const startBackgroundColor = animationType.split('_')[0] === 'purple' ? 'bg-purple-800' : 'bg-primary-black';
  topBar.classList.add(startBackgroundColor, 'transition', 'ease-in-out', 'duration-1000');
  if (startBackgroundColor === 'bg-primary-black') topBar.classList.add('text-primary-white');
  setTimeout(() => {
    topBar.classList.remove(startBackgroundColor);
    topBar.classList.add('bg-primary-white');
    if (startBackgroundColor === 'bg-primary-black') {
      topBar.classList.remove('text-primary-white');
      topBar.classList.add('text-primary-black');
    }
  }, 1800);
};
